document.querySelectorAll('.add-to-cart-btn').forEach((button) => {
  button.addEventListener('click', function(event) {
    const productSection = button.closest('.target-allproductsmain');

    const productTitle = productSection.querySelector('.producttitle')?.innerText?.trim() || 'Produit inconnu';
    const productId = productSection.querySelector('input[name="id"]')?.value || 'ID inconnu';

    let rawPrice = productSection.querySelector('.price [regular-price]')?.dataset.price || 0;
    // Convertir le prix en nombre avec sécurité
    const productPrice = parseFloat(rawPrice.toString().replace(',', '.').replace(/[^\d.]/g, '')) / 100 || 0;

    const productVariant = productSection.querySelector('select[name="id"] option:checked')?.innerText?.trim() || 'Default';
    const productCategory = productSection.dataset.productType || 'Non défini';

    // Pousser dans le dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'add_to_cart',
      ecommerce: {
        currency: window.shopifyCurrency || 'EUR',
        items: [{
          item_name: productTitle,
          item_id: productId,
          price: productPrice,
          item_brand: window.shopifyBrand || 'lunettes-a-trous.com',
          item_category: productCategory,
          item_variant: productVariant,
          quantity: 1
        }]
      }
    });
  });
});

function getFocusableElements(container) {
  return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"))
}
document.querySelectorAll('[id^="Details-"] summary').forEach((summary => {
  summary.setAttribute("role", "button"), summary.setAttribute("aria-expanded", "false"), summary.nextElementSibling.getAttribute("id") && summary.setAttribute("aria-controls", summary.nextElementSibling.id), summary.addEventListener("click", (event => {
    event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"))
  })), summary.closest("header-drawer") || summary.parentElement.addEventListener("keyup", onKeyUpEscape)
}));
const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container),
    first = elements[0],
    last = elements[elements.length - 1];
  removeTrapFocus(), trapFocusHandlers.focusin = event => {
    event.target !== container && event.target !== last && event.target !== first || document.addEventListener("keydown", trapFocusHandlers.keydown)
  }, trapFocusHandlers.focusout = function() {
    document.removeEventListener("keydown", trapFocusHandlers.keydown)
  }, trapFocusHandlers.keydown = function(event) {
    "TAB" === event.code.toUpperCase() && (event.target !== last || event.shiftKey || (event.preventDefault(), first.focus()), event.target !== container && event.target !== first || !event.shiftKey || (event.preventDefault(), last.focus()))
  }, document.addEventListener("focusout", trapFocusHandlers.focusout), document.addEventListener("focusin", trapFocusHandlers.focusin), elementToFocus.focus()
}

function fireClickOnEnterKeydown(element) {
  element.addEventListener("keydown", (function(event) {
    13 === event.keyCode && (event.preventDefault(), element.click())
  }))
}
try {
  document.querySelector(":focus-visible")
} catch {
  focusVisiblePolyfill()
}

function focusVisiblePolyfill() {
  const navKeys = ["ARROWUP", "ARROWDOWN", "ARROWLEFT", "ARROWRIGHT", "TAB", "ENTER", "SPACE", "ESCAPE", "HOME", "END", "PAGEUP", "PAGEDOWN"];
  let currentFocusedElement = null,
    mouseClick = null;
  window.addEventListener("keydown", (event => {
    navKeys.includes(event.code.toUpperCase()) && (mouseClick = !1)
  })), window.addEventListener("mousedown", (event => {
    mouseClick = !0
  })), window.addEventListener("focus", (() => {
    currentFocusedElement && currentFocusedElement.classList.remove("focused"), mouseClick || (currentFocusedElement = document.activeElement, currentFocusedElement.classList.add("focused"))
  }), !0)
}

function pauseMedia() {
  document.querySelectorAll(".js-youtube").forEach((video => {
    video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*")
  })), document.querySelectorAll(".js-vimeo").forEach((video => {
    video.contentWindow.postMessage('{"method":"pause"}', "*")
  })), document.querySelectorAll("video").forEach((video => video.pause())), document.querySelectorAll("product-model").forEach((model => {
    model.modelViewerUI && model.modelViewerUI.pause()
  }))
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin), document.removeEventListener("focusout", trapFocusHandlers.focusout), document.removeEventListener("keydown", trapFocusHandlers.keydown), elementToFocus && elementToFocus.focus()
}

function onKeyUpEscape(event) {
  if ("ESCAPE" !== event.code.toUpperCase()) return;
  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;
  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open"), summaryElement.setAttribute("aria-expanded", !1), summaryElement.focus()
}
class QuantityInput extends HTMLElement {
  constructor() {
    super(), this.input = this.querySelector("input"), this.changeEvent = new Event("change", {
      bubbles: !0
    }), this.querySelectorAll("button").forEach((button => button.addEventListener("click", this.onButtonClick.bind(this))))
  }
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    "plus" === event.target.name ? this.input.stepUp() : this.input.stepDown(), previousValue !== this.input.value && this.input.dispatchEvent(this.changeEvent)
  }
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t), t = setTimeout((() => fn.apply(this, args)), wait)
  }
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`
    }
  }
}
customElements.define("quantity-input", QuantityInput), void 0 === window.Shopify && (window.Shopify = {}), Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments)
  }
}, Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) return selector.selectedIndex = i, i
  }
}, Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, !1) : target.attachEvent("on" + eventName, callback)
}, Shopify.postLink = function(path, options) {
  var method = (options = options || {}).method || "post",
    params = options.parameters || {},
    form = document.createElement("form");
  for (var key in form.setAttribute("method", method), form.setAttribute("action", path), params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden"), hiddenField.setAttribute("name", key), hiddenField.setAttribute("value", params[key]), form.appendChild(hiddenField)
  }
  document.body.appendChild(form), form.submit(), document.body.removeChild(form)
}, Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid), this.provinceEl = document.getElementById(province_domid), this.provinceContainer = document.getElementById(options.hideElement || province_domid), Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)), this.initCountry(), this.initProvince()
}, Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value), this.countryHandler()
  },
  initProvince: function() {
    var value = this.provinceEl.getAttribute("data-default");
    value && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, value)
  },
  countryHandler: function(e) {
    var raw = (opt = this.countryEl.options[this.countryEl.selectedIndex]).getAttribute("data-provinces"),
      provinces = JSON.parse(raw);
    if (this.clearOptions(this.provinceEl), provinces && 0 == provinces.length) this.provinceContainer.style.display = "none";
    else {
      for (var i = 0; i < provinces.length; i++) {
        var opt;
        (opt = document.createElement("option")).value = provinces[i][0], opt.innerHTML = provinces[i][1], this.provinceEl.appendChild(opt)
      }
      this.provinceContainer.style.display = ""
    }
  },
  clearOptions: function(selector) {
    for (; selector.firstChild;) selector.removeChild(selector.firstChild)
  },
  setOptions: function(selector, values) {
    var i = 0;
    for (values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i], opt.innerHTML = values[i], selector.appendChild(opt)
    }
  }
};
class MenuDrawer extends HTMLElement {
  constructor() {
    super(), this.mainDetailsToggle = this.querySelector("details"), "iPhone" === navigator.platform && document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`), this.addEventListener("keyup", this.onKeyUp.bind(this)), this.bindEvents()
  }
  bindEvents() {
    this.querySelectorAll("summary").forEach((summary => summary.addEventListener("click", this.onSummaryClick.bind(this)))), this.querySelectorAll(".header_icon_humburger_h").forEach((summary => {
      summary.addEventListener("touchstart", this.onMainSummaryClick.bind(this), {
        passive: !0
      }), summary.addEventListener("click", this.onMainSummaryClick.bind(this), {
        passive: !0
      }), fireClickOnEnterKeydown(summary)
    })), this.querySelectorAll(".menu_drawer_summary_first").forEach((summary => summary.addEventListener("click", this.onFirstSummaryClick.bind(this)))), this.querySelectorAll("button:not(.disclosure__button)").forEach((button => button.addEventListener("click", this.onCloseButtonClick.bind(this)))), this.querySelectorAll(".close_bnt_drawer").forEach((button => button.addEventListener("click", this.onCloseClick.bind(this))))
  }
  onMainSummaryClick(event) {
    event.preventDefault(), document.querySelector("header-drawer").classList.add("open"), document.querySelector(".html_tag").style.overflow = "hidden", document.querySelector("header-drawer details").setAttribute("open", !0), document.querySelector("header-drawer details").classList.add("menu-opening");
    trapFocus(document.querySelector("#menu-drawer"))
  }
  onKeyUp(event) {
    if ("ESCAPE" !== event.code.toUpperCase()) return;
    const openDetailsElement = event.target.closest("details[open]");
    openDetailsElement && (openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, document.querySelector("summary.header_icon_humburger_h")) : this.closeSubmenu(openDetailsElement))
  }
  onSummaryClick(event) {
    const summaryElement = event.currentTarget,
      detailsElement = summaryElement.parentNode,
      isOpen = detailsElement.hasAttribute("open");
    window.matchMedia("(prefers-reduced-motion: reduce)");
    document.querySelector(".html_tag").style.overflow = "hidden", detailsElement === this.mainDetailsToggle ? (isOpen && event.preventDefault(), isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement)) : setTimeout((() => {
      detailsElement.classList.add("menu-opening"), summaryElement.setAttribute("aria-expanded", !0)
    }), 100)
  }
  onFirstSummaryClick(event) {
    setTimeout((() => {
      document.querySelector(".menu-drawer__inner-container").style.top = "0px"
    }), 180)
  }
  openMenuDrawer(summaryElement) {
    setTimeout((() => {
      this.mainDetailsToggle.classList.add("menu-opening")
    })), summaryElement.setAttribute("aria-expanded", !0), trapFocus(this.mainDetailsToggle, summaryElement), document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
  }
  closeMenuDrawer(event, elementToFocus = !1) {
    this.mainDetailsToggle.classList.remove("menu-opening"), this.mainDetailsToggle.querySelectorAll("details").forEach((details => {
      details.removeAttribute("open"), details.classList.remove("menu-opening")
    })), document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`), removeTrapFocus(elementToFocus), this.closeAnimation(this.mainDetailsToggle), document.querySelector(".html_tag").style.overflow = "unset", document.querySelector("header-drawer").classList.remove("open"), document.querySelector(".menu-drawer__inner-container").style.top = "60px"
  }
  onCloseClick(event) {
    document.querySelector(".html_tag").style.overflow = "unset", document.querySelector(".menu-drawer__inner-container").style.top = "60px", document.querySelector("header-drawer").classList.remove("open"), document.querySelectorAll("details").forEach((details => {
      details.removeAttribute("open"), details.classList.remove("menu-opening")
    }))
  }
  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement), document.querySelector(".html_tag").style.overflow = "unset", document.querySelector(".menu-drawer__inner-container").style.top = "60px", document.querySelectorAll(".menu-drawer__navigation details").forEach((details => {
      details.removeAttribute("open"), details.classList.remove("menu-opening")
    }))
  }
  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening"), removeTrapFocus(detailsElement.querySelector("summary")), this.closeAnimation(detailsElement)
  }
  closeAnimation(detailsElement) {
    let animationStart;
    const handleAnimation = time => {
      void 0 === animationStart && (animationStart = time);
      time - animationStart < 400 ? window.requestAnimationFrame(handleAnimation) : (detailsElement.removeAttribute("open"), detailsElement.closest("details[open]") && trapFocus(detailsElement.closest("details[open]"), detailsElement.querySelector("summary")))
    };
    window.requestAnimationFrame(handleAnimation)
  }
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer {
  constructor() {
    super()
  }
  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById("shopify-section-header"), this.borderOffset = this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0, document.documentElement.style.setProperty("--header-bottom-position", `${parseInt(this.header.getBoundingClientRect().bottom-this.borderOffset)}px`), this.header.classList.add("menu-open"), setTimeout((() => {
      this.mainDetailsToggle.classList.add("menu-opening")
    })), summaryElement.setAttribute("aria-expanded", !0), trapFocus(this.mainDetailsToggle, summaryElement), document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
  }
}
customElements.define("header-drawer", HeaderDrawer);
class ModalDialog extends HTMLElement {
  constructor() {
    super(), this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this)), this.addEventListener("keyup", (event => {
      "ESCAPE" === event.code.toUpperCase() && this.hide()
    })), this.classList.contains("media-modal") ? this.addEventListener("pointerup", (event => {
      "mouse" !== event.pointerType || event.target.closest("deferred-media, product-model") || this.hide()
    })) : this.addEventListener("click", (event => {
      "MODAL-DIALOG" === event.target.nodeName && this.hide()
    }))
  }
  connectedCallback() {
    this.moved || (this.moved = !0, document.body.appendChild(this))
  }
  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden"), this.setAttribute("open", ""), popup && popup.loadContent(), trapFocus(this, this.querySelector('[role="dialog"]')), window.pauseMedia()
  }
  hide() {
    document.body.classList.remove("overflow-hidden"), this.removeAttribute("open"), removeTrapFocus(this.openedBy), window.pauseMedia()
  }
}
customElements.define("modal-dialog", ModalDialog);
class ModalOpener extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector("button");
    button && button.addEventListener("click", (() => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      modal && modal.show(button)
    }))
  }
}
customElements.define("modal-opener", ModalOpener);
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    poster && poster.addEventListener("click", this.loadContent.bind(this))
  }
  loadContent(focus = !0) {
    if (window.pauseMedia(), !this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(!0)), this.setAttribute("loaded", !0);
      const deferredElement = this.appendChild(content.querySelector("video, model-viewer, iframe"));
      focus && deferredElement.focus()
    }
  }
}
customElements.define("deferred-media", DeferredMedia);
class SliderCompon extends HTMLElement {
  constructor() {
    if (super(), this.slider = this.querySelector('[id^="Slider-"]'), this.sliderItems = this.querySelectorAll('[id^="Slide-"]'), this.enableSliderLooping = !1, this.currentPageElement = this.querySelector(".slider-counter--current"), this.pageTotalElement = this.querySelector(".slider-counter--total"), this.prevButton = this.querySelector('button[name="previous"]'), this.nextButton = this.querySelector('button[name="next"]'), !this.slider || !this.nextButton) return;
    this.initPages();
    new ResizeObserver((entries => this.initPages())).observe(this.slider), this.slider.addEventListener("scroll", this.update.bind(this)), this.prevButton.addEventListener("click", this.onButtonClick.bind(this)), this.nextButton.addEventListener("click", this.onButtonClick.bind(this))
  }
  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element => element.clientWidth > 0)), this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1], 0 !== this.sliderItemsToShow.length && (this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth), this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1, this.update())
  }
  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]'), this.initPages()
  }
  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1, this.currentPageElement && this.pageTotalElement && (this.currentPageElement.textContent = this.currentPage, this.pageTotalElement.textContent = this.totalPages), this.currentPage != previousPage && this.dispatchEvent(new CustomEvent("slideChanged", {
      detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }
    })), this.enableSliderLooping || (this.isSlideVisible(this.sliderItemsToShow[0]) ? this.prevButton.setAttribute("disabled", "disabled") : this.prevButton.removeAttribute("disabled"), this.isSlideVisible(this.sliderLastItem) ? this.nextButton.setAttribute("disabled", "disabled") : this.nextButton.removeAttribute("disabled"))
  }
  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft
  }
  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = "next" === event.currentTarget.name ? this.slider.scrollLeft + step * this.sliderLastItem.clientWidth : this.slider.scrollLeft - step * this.sliderLastItem.clientWidth, this.slider.scrollTo({
      left: this.slideScrollPosition
    })
  }
}
customElements.define("slider-component", SliderCompon);
class SlideshowCompononent extends SliderCompon {
  constructor() {
    super(), this.sliderControlWrapper = this.querySelector(".slider-buttons"), this.enableSliderLooping = !0, this.sliderControlWrapper && (this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide"), this.sliderItemsToShow.length > 0 && (this.currentPage = 1), this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll(".slider-counter__link")), this.sliderControlLinksArray.forEach((link => link.addEventListener("click", this.linkToSlide.bind(this)))), this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this)), this.setSlideVisibility(), "true" === this.slider.getAttribute("data-autoplay") && this.setAutoPlay())
  }
  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay"), this.autoplaySpeed = 1e3 * this.slider.dataset.speed, this.sliderAutoplayButton.addEventListener("click", this.autoPlayToggle.bind(this)), this.addEventListener("mouseover", this.focusInHandling.bind(this)), this.addEventListener("mouseleave", this.focusOutHandling.bind(this)), this.addEventListener("focusin", this.focusInHandling.bind(this)), this.addEventListener("focusout", this.focusOutHandling.bind(this)), this.play(), this.autoplayButtonIsSetToPlay = !0
  }
  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = 1 === this.currentPage,
      isLastSlide = this.currentPage === this.sliderItemsToShow.length;
    (isFirstSlide || isLastSlide) && (isFirstSlide && "previous" === event.currentTarget.name ? this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length : isLastSlide && "next" === event.currentTarget.name && (this.slideScrollPosition = 0), this.slider.scrollTo({
      left: this.slideScrollPosition
    }))
  }
  update() {
    super.update(), this.sliderControlButtons = this.querySelectorAll(".slider-counter__link"), this.prevButton.removeAttribute("disabled"), this.sliderControlButtons.length && (this.sliderControlButtons.forEach((link => {
      link.classList.remove("slider-counter__link--active"), link.removeAttribute("aria-current")
    })), this.sliderControlButtons[this.currentPage - 1].classList.add("slider-counter__link--active"), this.sliderControlButtons[this.currentPage - 1].setAttribute("aria-current", !0))
  }
  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay), this.autoplayButtonIsSetToPlay ? this.pause() : this.play(), this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay
  }
  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    this.autoplayButtonIsSetToPlay && !focusedOnAutoplayButton && this.play()
  }
  focusInHandling(event) {
    (event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target)) && this.autoplayButtonIsSetToPlay ? this.play() : this.autoplayButtonIsSetToPlay && this.pause()
  }
  play() {
    this.slider.setAttribute("aria-live", "off"), clearInterval(this.autoplay), this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed)
  }
  pause() {
    this.slider.setAttribute("aria-live", "polite"), clearInterval(this.autoplay)
  }
  togglePlayButtonState(pauseAutoplay) {
    pauseAutoplay ? (this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused"), this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.playSlideshow)) : (this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused"), this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.pauseSlideshow))
  }
  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    })
  }
  setSlideVisibility() {
    this.sliderItemsToShow.forEach(((item, index) => {
      const button = item.querySelector("a");
      index === this.currentPage - 1 ? (button && button.removeAttribute("tabindex"), item.setAttribute("aria-hidden", "false"), item.removeAttribute("tabindex")) : (button && button.setAttribute("tabindex", "-1"), item.setAttribute("aria-hidden", "true"), item.setAttribute("tabindex", "-1"))
    }))
  }
  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    })
  }
}
customElements.define("slideshow-component", SlideshowCompononent);
class VariantSelects extends HTMLElement {
  constructor() {
    super(), this.addEventListener("change", this.onVariantChange)
  }
  onVariantChange() {    
    this.updateOptions(), this.updateMasterId(), this.toggleAddButton(!0, "", !1), this.updatePickupAvailability(), this.removeErrorMessage(), this.addtocart_btnUpdated(), this.updatePrice(), this.updateMedia(), this.updateVariantInput(), null != this.currentVariant && (1 == !this.currentVariant.available ? this.toggleAddButton(!0, "", !0) : (document.body.classList.contains("template--product") && this.updateURL(), this.renderProductInfo(), this.updateShareUrl()))
  }
  addtocart_btnUpdated() {
    var elemsection = document.getElementById(`product-form-${this.dataset.section}`);
    var add_to_cart = elemsection.querySelector(".target-allproducts__main input.add-to-cart-btn.button.primary_btn").getAttribute("data-add_to_cart"),
      sold_out = elemsection.querySelector(".target-allproducts__main input.add-to-cart-btn.button.primary_btn").getAttribute("data-sold_out"),
      unavailable = elemsection.querySelector(".target-allproducts__main input.add-to-cart-btn.button.primary_btn").getAttribute("data-unavailable");
    if (null !== elemsection.querySelector(".target-allproducts__main p.stock__quantity")) elemsection.querySelector(".target-allproducts__main p.stock__quantity").getAttribute("data-in_stock"), unavailable = elemsection.querySelector(".target-allproducts__main p.stock__quantity").getAttribute("data-unavailable");
    null != this.currentVariant ? 0 == this.currentVariant.available ? (elemsection.querySelector(".target-allproducts__main input.add-to-cart-btn.button.primary_btn").disabled = !0, elemsection.querySelector(".target-allproducts__main input.add-to-cart-btn.button.primary_btn").value = sold_out, null !== elemsection.querySelector(".target-allproducts__main p.stock__quantity") && (elemsection.querySelector(".target-allproducts__main p.stock__quantity .instock_span").classList.add("hide"), elemsection.querySelector(".target-allproducts__main p.stock__quantity .outofstock_span").classList.remove("hide"), elemsection.querySelector(".target-allproducts__main p.stock__quantity .unavailable_span").classList.add("hide"))) : (elemsection.querySelector(".target-allproducts__main input.add-to-cart-btn.button.primary_btn").disabled = !1, elemsection.querySelector(".target-allproducts__main input.add-to-cart-btn.button.primary_btn").value = add_to_cart, elemsection.closest('.target-allproducts__main').querySelector(".price.feature_price").classList.remove("price--sold-out"), null !== elemsection.querySelector(".target-allproducts__main p.stock__quantity") && (elemsection.querySelector(".target-allproducts__main p.stock__quantity .instock_span").classList.remove("hide"), elemsection.querySelector(".target-allproducts__main p.stock__quantity .outofstock_span").classList.add("hide"), elemsection.querySelector(".target-allproducts__main p.stock__quantity .unavailable_span").classList.add("hide"))) : (elemsection.querySelector(".target-allproducts__main input.add-to-cart-btn.button.primary_btn").disabled = !0, elemsection.querySelector(".target-allproducts__main input.add-to-cart-btn.button.primary_btn").value = unavailable, elemsection.closest('.target-allproducts__main').querySelector(".price.feature_price").classList.add("price--sold-out"), null !== elemsection.querySelector(".target-allproducts__main p.stock__quantity") && (elemsection.querySelector(".target-allproducts__main p.stock__quantity .instock_span").classList.add("hide"), elemsection.querySelector(".target-allproducts__main p.stock__quantity .outofstock_span").classList.add("hide"), elemsection.querySelector(".target-allproducts__main p.stock__quantity .unavailable_span").classList.remove("hide")))
  }
  updateOptions() {
    this.options = Array.from(this.querySelectorAll("select"), (select => select.value))
  }
  updateUnitPrice(){
    if(!this.currentVariant) return
    const currentVariantId = this.currentVariant.id;
    const currentUnitPrice = document.querySelector(
      `select[name='id'] option[value='${currentVariantId}']`
    )?.dataset.unitPrice;

    if (currentUnitPrice) {
      document.querySelector(
        ".unit-price > dd > span:first-child"
      ).textContent = currentUnitPrice;
      document.querySelector(".unit-price > dd").style.display = "block";
    } else {
      document.querySelector(".unit-price > dd").style.display = "none";
    }
  }
  updateMasterId() {
    if (this.currentVariant = this.getVariantData().find((variant => !variant.options.map(((option, index) => this.options[index] === option)).includes(!1))), this.classList.contains("quickview_options") && null != this.currentVariant) {
      var variant_info = this.currentVariant.title;
      document.body.querySelector(".quick-view-model .quickView_variant-info p").innerHTML = variant_info
    }
    this.updateUnitPrice()
  }
  updatePrice() {
    if (null != this.currentVariant && ("undefined" != this.currentVariant || null != this.currentVariant || null != this.currentVariant || "" != this.currentVariant)) {
      var price_cal = this.currentVariant.price,
        compare_price_cal = this.currentVariant.compare_at_price;
      this.classList.contains("feature-section") ? null != compare_price_cal ? (this.parentNode.parentNode.querySelector(".price.feature_price").classList.add("price--on-sale"), this.parentNode.parentNode.querySelector("[regular-price-sale]").innerHTML = Shopify.formatMoney(price_cal), this.parentNode.parentNode.querySelector("[regular-price-compare]").innerHTML = Shopify.formatMoney(compare_price_cal)) : (this.parentNode.parentNode.querySelector(".price.feature_price").classList.remove("price--on-sale"), this.parentNode.parentNode.querySelector("[regular-price]").innerHTML = Shopify.formatMoney(price_cal)) : this.classList.contains("quickview_options") ? null != compare_price_cal ? (document.querySelector(".quick-view_price .price.feature_price").classList.add("price--on-sale"), document.querySelector(".quick-view_price [regular-price-sale]").innerHTML = Shopify.formatMoney(price_cal), document.querySelector(".quick-view_price [regular-price-compare]").innerHTML = Shopify.formatMoney(compare_price_cal)) : (document.querySelector(".quick-view_price .price.feature_price").classList.remove("price--on-sale"), document.querySelector(".quick-view_price [regular-price]").innerHTML = Shopify.formatMoney(price_cal)) : null != compare_price_cal ? (this.parentNode.querySelector(".price.feature_price").classList.add("price--on-sale"), this.parentNode.querySelector("[regular-price-sale]").innerHTML = Shopify.formatMoney(price_cal), this.parentNode.querySelector("[regular-price-compare]").innerHTML = Shopify.formatMoney(compare_price_cal)) : (this.parentNode.querySelector(".price.feature_price").classList.remove("price--on-sale"), this.parentNode.querySelector("[regular-price]").innerHTML = Shopify.formatMoney(price_cal))
    }

  }
  updateMedia() {
    var elemsection = 
      document.getElementById(`product-form-${this.dataset.section}`).closest('.shopify-section') ? 
      document.getElementById(`product-form-${this.dataset.section}`).closest('.shopify-section') :
      document.getElementById(`product-form-${this.dataset.section}`).closest('.quick-view-model');
    if (this.currentVariant && this.currentVariant.featured_media) {
      var media_id = this.currentVariant.featured_image.id;
      if (!this.classList.contains("quickview_options")) {
        var get_index = elemsection.querySelector('.product-slider-nav .product__thumb .product-single__media[image-id="' + media_id + '"]').click();
      }else{
        var get_index = elemsection.querySelector('.product-slider-main .product-single__media[image-id="' + media_id + '"]').getAttribute('image-index');
        if(quickView.flickity){
          console.log(quickView.flickity);
          quickView.flickity.slideshow.select(get_index);
        }
      }
    }
  }
  updateURL() {
    this.updateUnitPrice()
    
    if(document.getElementById(`shopify-section-${this.dataset.section}`).querySelector('[data-section-type="featured-product"]')){
    }else{
      this.currentVariant && "false" !== this.dataset.updateUrl && (window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`), document.querySelector('[data-type="add-to-cart-form"] [name="id"]').value = this.currentVariant.id)
    }
  }
  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    shareButton && shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`)
  }
  updateVariantInput() {

    const productFormSelects = document.querySelectorAll(`#shopify-section-${this.dataset.section} form[data-type="add-to-cart-form"]`);

    productFormSelects.forEach((productForm => {
      const input = productForm.querySelector('input[name="id"]');
      null != this.currentVariant && (input.value = this.currentVariant.id, input.dispatchEvent(new Event("change", {
        bubbles: !0
      })))
    }))
  }
  updatePickupAvailability() {
    const elemSection = document.querySelector(
      `#shopify-section-${this.dataset.section}`
    );
    let pickUpAvailability = document.querySelector('pickup-availability')
    if(elemSection){
      pickUpAvailability = elemSection.querySelector("pickup-availability");
    }
    pickUpAvailability && (this.currentVariant && this.currentVariant.available ? pickUpAvailability.fetchAvailability(this.currentVariant.id) : (pickUpAvailability.removeAttribute("available"), pickUpAvailability.innerHTML = ""))
  }
  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;
    const productForm = section.querySelector("product-form");
    productForm && productForm.handleErrorMessage()
  }
  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`).then((response => response.text())).then((responseText => {
      const id = `price-${this.dataset.section}`,
        html = (new DOMParser).parseFromString(responseText, "text/html"),
        destination = document.getElementById(id),
        source = html.getElementById(id);
      source && destination && (destination.innerHTML = source.innerHTML);
      const price = document.getElementById(`price-${this.dataset.section}`);
      price && price.classList.remove("visibility-hidden"), this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut)
    }))
  }
  toggleAddButton(disable = !0, text, modifyClass = !0) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]'),
      addButtonText = productForm.querySelector('[name="add"] > span');
    addButton && (disable ? (addButton.setAttribute("disabled", "disabled"), text && (addButtonText.textContent = text)) : (addButton.removeAttribute("disabled"), addButtonText.textContent = window.variantStrings.addToCart))
  }
  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`),
      addButton = button.querySelector('[name="add"] input');
    document.getElementById(`price-${this.dataset.section}`);
    addButton && button.querySelector('[name="add"] input').setAttribute("value", "Sold out")
  }
  getVariantData() {
    return this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent), this.variantData
  }
}
customElements.define("variant-selects", VariantSelects);
class VariantRadios extends VariantSelects {
  constructor() {
    super()
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset => Array.from(fieldset.querySelectorAll("input")).find((radio => radio.checked)).value))
  }
}
customElements.define("variant-radios", VariantRadios);
// === Tracking modification de quantité ===
document.addEventListener('change', function(e) {
  if (e.target.matches('.cart-item__quantity input')) {
    const itemEl = e.target.closest('[data-line-item]');
    const productId = itemEl?.dataset?.productId;
    const quantity = parseInt(e.target.value, 10);

    if (productId && quantity >= 1) {
      // Événement GA4 / Meta sur update
      pushDataLayer('add_to_cart', {
        currency: Shopify.currency.active,
        items: [{
          item_id: productId,
          quantity: quantity
        }]
      });

      sendGA4Event('add_to_cart', {
        currency: Shopify.currency.active,
        items: [{
          item_id: productId,
          quantity: quantity
        }]
      });

      sendMetaEvent('AddToCart', {
        content_ids: [productId],
        content_type: 'product',
        currency: Shopify.currency.active
      });
    }
  }
});

// === Tracking suppression produit ===
document.addEventListener('click', function(e) {
  if (e.target.closest('.cart-item__remove')) {
    const itemEl = e.target.closest('[data-line-item]');
    const productId = itemEl?.dataset?.productId;

    if (productId) {
      pushDataLayer('remove_from_cart', {
        currency: Shopify.currency.active,
        items: [{
          item_id: productId
        }]
      });

      sendGA4Event('remove_from_cart', {
        currency: Shopify.currency.active,
        items: [{
          item_id: productId
        }]
      });

      sendMetaEvent('RemoveFromCart', {
        content_ids: [productId],
        content_type: 'product',
        currency: Shopify.currency.active
      });
    }
  }
});
// === Tracking modification de quantité ===
document.addEventListener('change', function(e) {
  if (e.target.matches('.cart-item__quantity-input')) {
    const itemEl = e.target.closest('[data-line-item]');
    if (!itemEl) return;

    const productId = itemEl.dataset.productId;
    const variantId = itemEl.dataset.variantId;
    const quantity = parseInt(e.target.value, 10);
    const price = parseFloat(itemEl.dataset.price || 0);

    if (productId && quantity > 0) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
          currency: 'EUR',
          items: [{
            item_id: productId,
            item_variant: variantId,
            price: price,
            quantity: quantity
          }]
        }
      });

      gtag('event', 'add_to_cart', {
        currency: 'EUR',
        items: [{
          item_id: productId,
          item_variant: variantId,
          price: price,
          quantity: quantity
        }]
      });

      fbq('track', 'AddToCart', {
        content_ids: [productId],
        content_type: 'product',
        value: price * quantity,
        currency: 'EUR'
      });
    }
  }
});

// === Tracking suppression produit ===
document.addEventListener('click', function(e) {
  if (e.target.closest('.cart-item__remove')) {
    const itemEl = e.target.closest('[data-line-item]');
    if (!itemEl) return;

    const productId = itemEl.dataset.productId;
    const variantId = itemEl.dataset.variantId;
    const price = parseFloat(itemEl.dataset.price || 0);

    if (productId) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'remove_from_cart',
        ecommerce: {
          currency: 'EUR',
          items: [{
            item_id: productId,
            item_variant: variantId,
            price: price
          }]
        }
      });

      gtag('event', 'remove_from_cart', {
        currency: 'EUR',
        items: [{
          item_id: productId,
          item_variant: variantId,
          price: price
        }]
      });

      fbq('track', 'RemoveFromCart', {
        content_ids: [productId],
        content_type: 'product',
        value: price,
        currency: 'EUR'
      });
    }
  }
});
